<template>
  <v-container fluid fill-height grid-list-xs pa-0 class="mt-2">
    <v-layout row wrap align-stretch>
      <v-form v-model="valid" style="width: 100%;" class="mb-2">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm5 md3>
            <v-flex xs12>
              Proprietário
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="[
                  { text: 'Todos', value: 1 },
                  { text: 'Cliente', value: 2 },
                  { text: 'Empresa', value: 3 },
                  { text: 'Posto', value: 4 }
                ]"
                v-model="filtro_proprietario"
                label="Tipo de proprietário"
                item-text="text"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="itens_proprietario"
                :disabled="filtro_proprietario === 1"
                label="Filtro do proprietário"
                item-text="text"
                item-value="value"
                v-model="item_selecionado"
                return-object
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-if="item_selecionado"
                :disabled="filtro_proprietario === 1"
                v-model="pesquisa_proprietario"
                :label="item_selecionado.text"
              ></v-text-field>
            </v-flex>
          </v-flex>
          <v-divider vertical/>
          <v-flex xs12 sm10 md4>
            <v-flex xs12>Dados da Carteira</v-flex>
            <v-layout xs12>
              <v-flex xs6>
                <v-text-field label="Maior que" type="number" v-model="maior_valor"/>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Menor que"
                  type="number"
                  v-model="menor_valor"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-divider vertical/>
           <v-flex shrink>
             <v-btn icon color="info" @click="carregarRelatorio(true)"><v-icon>search</v-icon></v-btn>
           </v-flex>
          <v-flex shrink>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile
                  @click="editando = !editando"
                >
                  <v-list-tile-action>
                    <v-icon v-if="!editando">edit</v-icon>
                    <v-icon v-else>done</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Editar Relatório</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="print()"
                >
                  <v-list-tile-action>
                    <v-icon>print</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Imprimir Relatório</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 class="print">
        <v-data-table
          hide-actions
          :hide-headers="!carteiras || !carteiras.length"
          :loading="loading"
          :items="carteiras"
          :pagination.sync="pagination"
          :total-items="totalItens"
          class="elevation-1"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-3" v-if="headersVisible.avatar">
                <v-icon color="success">attach_money</v-icon>
              </td>
              <td class="text-xs-left" v-if="headersVisible.proprietario">
                <template v-if="props.item.pessoa">
                  {{`Usuário: ${props.item.pessoa.nome_completo}` | truncate(30) }}
                  <div>ID: <strong>{{props.item.pessoa.id_pessoa}}</strong></div>
                </template>
                <template v-if="props.item.empresa">
                  {{`Empresa: ${props.item.empresa.nome_fantasia}` | truncate(30) }}
                  <div>CNPJ: <strong>{{props.item.empresa.cnpj}}</strong></div>
                </template>
                <template v-if="props.item.posto">
                  {{`Posto: ${props.item.posto.nome_fantasia}` | truncate(30) }}
                  <div>CNPJ: <strong>{{props.item.posto.cnpj}}</strong></div>
                </template>
              </td>
              <td class="text-xs-right pl-2 pr-4"   v-if="headersVisible.historico">
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click="carteiraSelecionada =  props.item, dialogHistorico = true"
                  >
                    <v-icon>account_balance_wallet</v-icon>
                  </v-btn>
                  <span>Visualizar Histórico</span>
                </v-tooltip>
              </td>
              <td class="text-xs-right pl-2 pr-4"   v-if="headersVisible.saldo">
                <strong>{{ props.item.saldo | currency({ fractionCount: 2 }) }}</strong>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-center px-4" v-if="headersVisible.avatar">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.avatar = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.proprietario">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.proprietario = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Proprietário
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.historico">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.historico = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Histórico
              </th>
              <th class="text-xs-right pl-2 pr-4" v-if="headersVisible.saldo">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.saldo = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor (R$)
              </th>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="carteiras.length">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Valor total da Divida: {{ valor_total_divida | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
    <v-dialog
      v-model="dialogHistorico"
      v-if="dialogHistorico"
      width="500"
      scrollable
    >
      <historico-carteira
        :carteiraObj="carteiraSelecionada"
        :empresa="carteiraSelecionada.empresa"
        :posto="carteiraSelecionada.posto"
        :pessoa="carteiraSelecionada.pessoa"
        :is_cashposto="false"
        @fechar="
          dialogHistorico = false,
          carteiraSelecionada = {
            empresa: undefined,
            posto: undefined,
            pessoa: undefined
          }
        "
      />
    </v-dialog>
  </v-container>
</template>

<script>
import HistoricoCarteira from '@/components/dialogs/HistoricoCarteira'

export default {
  components: { HistoricoCarteira },
  data () {
    return {
      valor_total_divida: 0,
      valid: false,
      editando: false,
      dialogHistorico: false,
      carteiraSelecionada: {
        empresa: undefined,
        posto: undefined,
        pessoa: undefined
      },
      filtro_proprietario: 1,
      item_selecionado: undefined,
      pesquisa_proprietario: '',
      menor_valor: undefined,
      maior_valor: undefined,
      headersVisible: {
        proprietario: true,
        historico: true,
        saldo: true,
        avatar: true
      },
      rules: {
        cpf: value => {
          return (value && value.length === 11) || 'CPF inválido.'
        }
      },
      carteiras: [],
      totalItens: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      const pages = Math.ceil(this.totalItens / this.pagination.rowsPerPage)
      return pages
    },
    itens_proprietario () {
      switch (this.filtro_proprietario) {
        case 2:
          return [
              { text: 'CPF', value: 'pessoa__cpf' },
              { text: 'Número de Identificação', value: 'pessoa__id_pessoa' },
              { text: 'E-mail', value: 'pessoa__email' },
              { text: 'Telefone', value: 'pessoa__telefone' }

          ]
        case 3:
          return [
            { text: 'CNPJ', value: 'empresa__cnpj' },
            { text: 'Nome fantasia', value: 'empresa__nome_fantasia__icontains' },
            { text: 'Cidade', value: 'empresa__endereco__cidade__icontains' },
            { text: 'Estado', value: 'empresa__endereco__estado__icontains' }
          ]
        case 4:
          return [
            { text: 'CNPJ', value: 'posto__cnpj' },
            { text: 'Nome fantasia', value: 'posto__nome_fantasia__icontains' },
            { text: 'Cidade', value: 'posto__endereco__cidade__icontains' },
            { text: 'Estado', value: 'posto__endereco__estado__icontains' }
          ]
        default:
          return []
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        if (this.headers) this.carregarRelatorio(false)
      },
      deep: true
    },
    headers (val) {
      if (val) {
        this.carregarRelatorio(true)
      }
    },
    itens_proprietario () {
      this.item_selecionado = undefined
    }
  },
  mounted () {
    if (this.headers) {
      this.carregarRelatorio(true)
    }
  },
  methods: {
    print () {
      window.print()
    },
    carregarRelatorio (zerarPaginacao) {
      const data = {
        page: zerarPaginacao ? 1 : this.pagination.page,
        page_size: this.pagination.rowsPerPage,
        is_cashposto: false,
        is_admin: true
      }
      // { text: 'Todos', value: 1 },
      // { text: 'Cliente', value: 2 },
      // { text: 'Empresa', value: 3 },
      // { text: 'Posto', value: 4 }
      if (this.filtro_proprietario !== 1) {
        data.pessoa__isnull = this.filtro_proprietario !== 2
        data.empresa__isnull = this.filtro_proprietario !== 3
        data.posto__isnull = this.filtro_proprietario !== 4
        if (this.pesquisa_proprietario) {
          data[`${this.item_selecionado.value}`] = this.pesquisa_proprietario
        }
      }
      if (this.maior_valor !== undefined) {
        data.saldo__gte = this.maior_valor
      }
      if (this.menor_valor !== undefined) {
        data.saldo__lte = this.menor_valor
      }
      this.$store.dispatch('pegarCarteirasVirtuais', data).then(json => {
        this.carteiras = json.results.carteiras
        this.totalItens = json.count
        this.valor_total_divida = json.results.valor_total
      })
    }
  }
}
</script>
